import { ALL_DATA_TYPES } from './dataTypes';

// Single subcondition for the Deal filter: Deal Status.
// `id` must be truthy so SelectWithSubQuery does not skip the options query.
export const DEAL_STATUS_SUBCONDITION = {
  key: 'deal_status',
  value: 'Deal Status',
  id: 'deal_status',
  dataType: ALL_DATA_TYPES.multi_select,
};

export const DEAL_OPTIONS = [DEAL_STATUS_SUBCONDITION];
